import { useTranslation } from "react-i18next";

import { type ModelConfig } from "~/shared/data/chat-models";
import { HEIGHT } from "~/shared/lib/design-tokens";
import { cn } from "~/shared/lib/utils";

interface ModelSelectorProps {
    models: readonly ModelConfig[];
    loading: boolean;
    selectedId: string | null;
    onSelect: (id: string) => void;
}

// Список доступных моделей текущего artifactType: loading / empty / тайлы с
// brand-лейблом и индикатором выбранной.
export function ModelSelector({ models, loading, selectedId, onSelect }: ModelSelectorProps) {
    const { t } = useTranslation("chat-settings");

    return (
        <div className="flex flex-col gap-1">
            {loading && <div className="px-3 py-2 text-xs text-zinc-500">{t("loading")}</div>}
            {!loading && models.length === 0 && (
                <div className="px-3 py-2 text-xs text-zinc-500">{t("noModels")}</div>
            )}
            {models.map((m) => (
                <button
                    key={m.id}
                    type="button"
                    onClick={() => onSelect(m.id)}
                    className={cn(
                        HEIGHT.tile,
                        "flex items-center justify-between rounded-md px-3 py-1.5 text-left text-xs",
                        "[touch-action:manipulation] transition-colors duration-100 select-none",
                        selectedId === m.id
                            ? "bg-violet-500/20 text-violet-50 ring-1 ring-violet-400/50 ring-inset"
                            : "text-zinc-400 hover:bg-white/5 hover:text-zinc-200",
                    )}
                >
                    <div className="flex flex-col gap-1">
                        <span className="text-xs font-medium">{m.name}</span>
                        <span className="text-[10px] text-zinc-600">{m.brandLabel}</span>
                    </div>
                    {selectedId === m.id && <div className="h-2 w-2 shrink-0 rounded-full bg-emerald-400" />}
                </button>
            ))}
        </div>
    );
}
